<template>
    <div>
        <v-toolbar
                dense
                tabs
                color="primary"
                dark
        >
            <!-- <v-toolbar-title class="pl-2">{{titles[navItem]}}</v-toolbar-title> -->
            <v-toolbar-title class="pl-2">{{this.$store.state.ui.titles[navItem]}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tabs
                    v-model="tabs"
                    slider-color="white"
                    slot="extension"
            >
                <v-tab
                        v-for="tabsItem in ui_tabsItems"
                        :key="tabsItem.id"
                        :to="tabsItem.link"
                >
                    <span class="pl-2 pr-2">{{ tabsItem.title }}</span>
                </v-tab>
            </v-tabs>
        </v-toolbar>

        <v-container>
            <v-layout row>
                <v-flex xs12 md12>
                    <v-slide-y-transition mode="out-in">
                        <router-view/>
                    </v-slide-y-transition>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    
    export default {
        created(){
            this.setNavItemName(this.navItem)
        },
        props: ["navItem"],
        data() {
            return {
                tabs: null,
                // tabsItems: [
                //     {id: 1, title: "グルコン一覧", link: "groupConsulting"},
                //     {id: 2, title: "セミナー一覧", link: "seminar"}
                // ],
                // tabsItems : [],
                titles : {
                    host : "主催一覧",
                    seminar : "セミナー一覧",
                    attend : "参加予定"
                }
            };
        },
        // watch: {
        //     // ルートが変更されたらこのメソッドを再び呼び出します
        //     '$route': 'changeTab'
        // },
        // beforeRouteUpdate (to, from, next) {
        //     // URL の id が変わったときに src/components/items-detail.vue の updateItem 関数を実行してモデルを更新する
        //     this.changeTab();
        //     next();
        // },
        methods:{
            ...mapActions("ui", ["setNavItemName"]),

        },
        computed:{
            
            ...mapGetters( ["role"]),
            ...mapGetters("ui", ["tabtitle", "ui_tabsItems"]),
        }
    };
</script>

<style scoped>

</style>
